import { render, staticRenderFns } from "./quesGuide122.vue?vue&type=template&id=27c020b6"
import script from "./quesGuide122.vue?vue&type=script&lang=js"
export * from "./quesGuide122.vue?vue&type=script&lang=js"
import style0 from "./quesGuide122.vue?vue&type=style&index=0&id=27c020b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports